module.exports = __webpack_public_path__ + "static/img/10.0ae619c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/10.png
// module id = ATmC
// module chunks = 0